module.exports = __webpack_public_path__ + "static/annotations-edfb1500b8b3cf444275e4af19a5dea0.gif";